<template>
  <span class="icon" v-html="icon[props.variant]"></span>
</template>

<script setup>
import { default as chevronLeftSvg } from '@/assets/img/icons/chevron-left-icon.svg?raw';
import { default as chevronRightSvg } from '@/assets/img/icons/chevron-right-icon.svg?raw';
import { default as propertiesSvg } from '@/assets/img/icons/properties-icon.svg?raw';
import { default as searchSvg } from '@/assets/img/icons/search-icon.svg?raw';
import { default as plusSvg } from '@/assets/img/icons/plus-icon.svg?raw';
import { default as minusSvg } from '@/assets/img/icons/minus-icon.svg?raw';
import { default as cartSvg } from '@/assets/img/icons/cart-icon.svg?raw';
import { default as closeSvg } from '@/assets/img/icons/close-icon.svg?raw';
import { default as closeLgSvg } from '@/assets/img/icons/close-icon-lg.svg?raw';
import { default as infoSvg } from '@/assets/img/icons/info-icon.svg?raw';
import { default as devicesSvg } from '@/assets/img/icons/devices-icon.svg?raw';
import { default as spaceSvg } from '@/assets/img/icons/space-icon.svg?raw';
import { default as removeSvg } from '@/assets/img/icons/remove-icon.svg?raw';
import { default as personSvg } from '@/assets/img/icons/person-icon.svg?raw';
import { default as logoSvg } from '@/assets/img/icons/logo-icon.svg?raw';
import { default as logoLgSvg } from '@/assets/img/icons/logo-lg-icon.svg?raw';
import { default as resetSvg } from '@/assets/img/icons/reset-icon.svg?raw';
import { default as cardSvg } from '@/assets/img/icons/card-icon.svg?raw';
import { default as sbpSvg } from '@/assets/img/icons/sbp-icon.svg?raw';

const props = defineProps({
    variant: {
        type: String,
        required: true
    }
});

const icon = {
    chevronLeft: chevronLeftSvg,
    chevronRight: chevronRightSvg,
    properties: propertiesSvg,
    search: searchSvg,
    plus: plusSvg,
    minus: minusSvg,
    cart: cartSvg,
    close: closeSvg,
    closeLg: closeLgSvg,
    info: infoSvg,
    devices: devicesSvg,
    space: spaceSvg,
    remove: removeSvg,
    person: personSvg,
    logo: logoSvg,
    logoLg: logoLgSvg,
    reset: resetSvg,
    card: cardSvg,
    sbp: sbpSvg
};
</script>
<style scoped lang="scss">
.icon {
    display: flex;
    align-items: center;
}
</style>